import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1694.136,1694.112 L1355.256,1694.112 L1355.256,1500.072 L1129.296,1500.072 L1129.296,1694.112 L790.536,1694.112 L790.536,1500.072 L564.576,1500.072 L564.576,1694.112 L225.816,1694.112 L225.816,226.032 L564.576,226.032 L564.576,425.832 L790.536,425.832 L790.536,226.032 L1129.296,226.032 L1129.296,425.832 L1355.256,425.832 L1355.256,226.032 L1694.136,226.032 L1694.136,1694.112 Z M1694.016,0.072 L225.816,0.072 C101.256,0.072 -0.024,101.352 -0.024,226.032 L-0.024,1694.112 C-0.024,1818.792 101.256,1920.072 225.816,1920.072 L1694.016,1920.072 C1818.576,1920.072 1919.976,1818.792 1919.976,1694.112 L1919.976,226.032 C1919.976,101.352 1818.576,0.072 1694.016,0.072 L1694.016,0.072 Z M1435.076,1201.532 L1193.756,960.212 L1435.076,719.012 L1201.316,485.132 L959.996,726.452 L718.676,485.132 L484.916,719.012 L726.236,960.212 L484.916,1201.532 L718.676,1435.172 L959.996,1193.972 L1201.316,1435.172 L1435.076,1201.532 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  transform: "rotate(90 959.976 960.072)"
});

var IconTableDeleteRowSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTableDeleteRowSolid, _Component);

  var _super = _createSuper(IconTableDeleteRowSolid);

  function IconTableDeleteRowSolid() {
    _classCallCheck(this, IconTableDeleteRowSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTableDeleteRowSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTableDeleteRow",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTableDeleteRowSolid.displayName = "IconTableDeleteRowSolid";
  return IconTableDeleteRowSolid;
}(Component);

IconTableDeleteRowSolid.glyphName = 'table-delete-row';
IconTableDeleteRowSolid.variant = 'Solid';
IconTableDeleteRowSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTableDeleteRowSolid;
export { IconTableDeleteRowSolid };